import { render, staticRenderFns } from "./c-section.vue?vue&type=template&id=79f71b46&scoped=true&"
import script from "./c-section.vue?vue&type=script&lang=js&"
export * from "./c-section.vue?vue&type=script&lang=js&"
import style0 from "./c-section.vue?vue&type=style&index=0&id=79f71b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f71b46",
  null
  
)

export default component.exports